import {Poker2Constants} from "../../../constants/Poker2Constants";
import {SFConstants} from "../../../constants/SFConstants";
import {ErrorCodes} from "../../../constants/shared/ErrorCodes";
import {Poker2PreloadEvent} from "../../../event/Poker2PreloadEvent";
import {Poker2Command} from "../Poker2Command";

export class CASPreCommand extends Poker2Command {
    /*override*/
    protected get cmdId(): string {
        return "cas";
    }

    /*override*/
    public executeCommand(error: number, params: any[]): boolean {
        var paramsObj: any;
        switch (error) {
            case 0:
                this.controller.dispatchEvent(new Poker2PreloadEvent("socialAvatarCreationSuccessful", ""));
                this.controller.dispatchEvent(new Poker2PreloadEvent("socialLoginSecondFrame", "socialLogin"));
                return true;
                break;
            case 22:
                if (params[1]) {
                    paramsObj = JSON.parse(params[1]);
                    if (paramsObj.NS)
                        this.controller.dispatchEvent(new Poker2PreloadEvent("socialavatarnamesuggestions", "", [paramsObj]));
                }
                break;
            default:
                this.controller.dispatchEvent(new Poker2PreloadEvent("socialRagisterFaild", "", [error]));
                break;
        }
        return super.executeCommand(error, params);
    }

    /**
     * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
     **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}


